:host {
  display: block;
}

.input-multiline__message {
  color: #6d6d6d;
  @apply text-sm mb-1;
}
